import {
  bool, string, number, shape,
} from 'prop-types'
import { format } from '@active/core/datetime'

import CreditCardImages from '../../../../shared/imgs/ccImgs/imgMap'
import ECheckImages from '../ECheckEUDD/imgs/imgMap'
import ACHImages from '../ACH/imgs/imgMap'

const paymentMethodTypes = {
  CREDIT_CARD: {
    getEnumType: () => 'CREDIT_CARD',
    getJsonType: () => 'CreditCardPaymentMethod',
    getCardName: function getCardName() { return [this.cardHolderName, 'credit-card'] },
    getSummaryData: function getSummaryData() {
      return format('MM/yyyy')(new Date(`${this.expiredYear}-${(Array(2).join('0') + this.expiredMonth).slice(-2)}-03T23:59:59Z`))
    },
    // Image, classname, default show icon
    getImages: function getImages() { return [CreditCardImages[this.cardType], 'credit-card', true] },
    getLastDigits: function getLastDigits() { return this.last4Digits },
    supportCategory: ['Person', 'Agency'],
  },
  ECHECK: {
    getEnumType: () => 'ECHECK',
    getJsonType: () => 'ECheckPaymentMethod',
    getCardName: function getCardName() { return [this.accountName, 'echeck'] },
    getSummaryData: function getSummaryData(i18n) {
      // Link to passport.lib.components.payment.echeck.CONSUMER_CHECKING
      // passport.lib.components.payment.echeck.CORPORATE_CHECKING
      // passport.lib.components.payment.echeck.CONSUMER_SAVINGS
      // passport.lib.components.payment.echeck.CORPORATE_SAVINGS
      return i18n(`passport.lib.components.payment.echeck.${this.accountType}`)
    },
    getImages: () => [ECheckImages.ECheck, 'echeck', false],
    getLastDigits: function getLastDigits() { return this.last2Digits },
    supportCategory: ['Person'],
  },
  EUDD: {
    getEnumType: () => 'ECHECK',
    getJsonType: () => 'EUDDPaymentMethod',
    getCardName: function getCardName() { return [this.accountName, 'echeck'] },
    getSummaryData: () => '',
    getImages: () => [ECheckImages.EUDD, 'echeck', false],
    getLastDigits: function getLastDigits() { return this.last2Digits },
    supportCategory: ['Person'],
  },
  ACH: {
    getEnumType: () => 'ACH',
    getJsonType: () => 'ACHPaymentMethod',
    getCardName: function getCardName() { return [this.BANK_NAME, 'ach'] },
    getSummaryData: () => '',
    getImages: () => [ACHImages.ACH, 'ach', false],
    getLastDigits: function getLastDigits() { return this.BANK_NAME },
    supportCategory: ['Agency'],
  },
}
const DEFAULT = {
  getEnumType: () => '',
  getJsonType: () => '',
  getCardName: () => ['', ''],
  getSummaryData: () => '',
  getImages: () => [],
  getLastDigits: () => '',
}
const paymentMethodTypeValues = Object.values(paymentMethodTypes)

paymentMethodTypes.getType = paymentMethod => paymentMethod && paymentMethodTypeValues.find(type => type.getJsonType() === paymentMethod['@type'])

paymentMethodTypes.convert = _paymentMethod => {
  let paymentMethod = _paymentMethod || {}

  const type = paymentMethodTypes.getType(paymentMethod)

  paymentMethod = Object.assign(paymentMethod, DEFAULT, type)

  return paymentMethod
}

export default paymentMethodTypes

const paymentMethodPropType = shape({
  '@type': string.isRequired,
  id: number.isRequired,
  address: shape({}).isRequired,
  displayName: string,
  primary: bool.isRequired,
  modifiedDate: string.isRequired,
  // Credit card
  last4Digits: string,
  cardHolderName: string,
  cardType: string,
  expiredYear: number,
  expiredMonth: number,
  expirationDate: string,
  // ECheck
  last2Digits: string,
  accountName: string,
  bankRoutingNumber: string,
  accountType: string,
  // EUDD
  bankCountryCode: string,
  // ACH
  SWIFT_BIC: string,
  BANK_NAME: string,
  BRANCH_NAME: string,
  IBAN: string,
  ROUTING_NUMBER: string,
  ACCOUNT_NUMBER: string,
  BANK_ACCOUNT_OWNER: string,
})

export { paymentMethodPropType, paymentMethodTypeValues }
